function MobileConsole($scope, $rootScope, $http) {
    this.rootScope = $rootScope;
    this.scope = $scope;
    this.Ui = $scope.Ui;
    this.consoleService = new ConsoleService($http);
    this.i18n = I18NService.create();
    this.io = io;
    this.pageStack = [];
    this.sensorPlotData = {};
    this.plotData = {};
    this.deviceAdvertisementDialog = {};
    this.userCreationDialog = {};
    this.deviceDialog = {};
    this.actorDialog = {};
    this.sensorDialog = {};
    this.messageDialog = {};
    this.confirmationDialog = {};
    this.loginDialog = {};
    this.storyboardStepEntryDialog = {};
    this.serviceCallDialog = {};
    this.pairGatewayDialog = {};
    this.postObjectDialog = {};

    this.consoleService.logDebug('Initializing Dialog');

    this.Ui.initialize($scope, "deviceAdvertisementDialog");
    this.Ui.initialize($scope, "userCreationDialog");
    this.Ui.initialize($scope, "deviceDialog");
    this.Ui.initialize($scope, "actorDialog");
    this.Ui.initialize($scope, "sensorDialog");
    this.Ui.initialize($scope, "messageDialog");
    this.Ui.initialize($scope, "confirmationDialog");
    this.Ui.initialize($scope, "loginDialog");
    this.Ui.initialize($scope, "storyboardStepEntryDialog");
    this.Ui.initialize($scope, "updateFirmwareDialog");
    this.Ui.initialize($scope, "serviceCallDialog");
    this.Ui.initialize($scope, "serverSettingsDialog");
    this.Ui.initialize($scope, "scanForLocalNodeBoxDialog");
    this.Ui.initialize($scope, "pairGatewayDialog");
    this.Ui.initialize($scope, "postObjectDialog");

    this.nodeConfigurationScope = 0;

    this.icons = ["icon sl-contacts-1",
        "icon sl-globe-1",
        "icon sl-house-1",
        "icon sl-house-2",
        "icon sl-sofa-3",
        "icon sl-bed",
        "icon sl-cocktail-1",
        "icon sl-tree",
        "icon sl-car-3",
        "icon sl-heartpulse",
        "icon sl-notes-1",
        "icon sl-camera-symbol-3",
        "icon sl-cloth-hanger",
        "icon sl-scale"];
    this.backgroundColors = ["lighterSecondaryBackgroundColor",
        "lighterTernaryBackgroundColor",
        "lighterPrimaryBackgroundColor",
        "lighterContrastBackgroundColor"];

    this.consoleService.logDebug('Initializing Settings');
    this.consoleService.initializeSettings();

    window.setTimeout(function () {
        this.startLoading("We are connecting you to the world of [thing-it].");
        this.start();
    }.bind(this), 0);
}

/**
 *
 */
MobileConsole.prototype.start = function () {
    try {
        this.consoleService.logDebug('Initializing Speech');

        this.speech = Speech.initialize(this);

        this.consoleService.logDebug('Initializing Server Communication');
        this.reinitializeServerCommunication();
        this.consoleService.logDebug('Adjusting Style');
        this.adjustStyle();
    } catch (error) {
        this.consoleService.logError(error);
        this.openConfirmationDialog("Sorry! Having issues to initialize thing-it Mobile. Retry?", function () {
            this.start();
        }.bind(this));
    }
};

/**
 *
 */
MobileConsole.prototype.getBackgroundColor = function (index) {
    return this.backgroundColors[index % this.backgroundColors.length];
};

/**
 *
 */
MobileConsole.prototype.reinitializeServerCommunication = function () {
    // Stop active polling

    if (this.connectionPollInterval) {
        clearInterval(this.connectionPollInterval);
    }

    this.consoleService.logDebug("Reinitializing Server Communication: " + this.consoleService.useLocalNodeBoxIfAvailable());

    if (this.consoleService.useLocalNodeBoxIfAvailable()) {
        // Periodically validate local connection
        this.consoleService.logDebug("Start polling");

        this.connectionPollInterval = setInterval(function () {
            this.consoleService.tryLocalConnection().done(function (changedConnectionMode) {
                if (changedConnectionMode) {
                    this.refreshServer();

                    if (this.hasLocalConnection()) {
                        this
                            .openMessageDialog("Found local Node Box and connected.", "info", 3000);
                    } else {
                        this
                            .openMessageDialog("Cannot reach local Node Box. Fell over to thing-it.com.", "info", 3000);
                    }
                }
            }.bind(this));
        }.bind(this), 30000);

        // Initial refresh

        this.consoleService.tryLocalConnection().done(function () {
            this.refreshServer();
        }.bind(this));
    }
    else {
        this.refreshServer();
    }
};

/**
 *
 */
MobileConsole.prototype.refreshServer = function () {
    this.consoleService.logDebug("Refreshing Server in mode " + this.consoleService.settings.serverMode);
    this.consoleService.logDebug("Use local " + this.consoleService.settings.useLocalNodeBoxIfAvailable);
    this.consoleService.logDebug("Connection Mode " + this.consoleService.connectionMode);
    this.consoleService.logDebug("And " + this.operatesInLocalMode());

    if (this.operatesInLocalMode()) {
        this.consoleService.logDebug("Operating in local mode.");
        this.afterLogin();

        // Obtain authentication settings

        //this.consoleService
        //    .getServerSettings()
        //    .done(
        //        function (settings) {
        //            this.consoleService.settings.authentication = settings.authentication;
        //
        //            if (!this.consoleService.settings.authentication || this.consoleService.settings.authentication == "none") {
        //                this.afterLogin();
        //            }
        //            else {
        //                // TODO Currently unsupported path
        //
        //                this.rootPage(new LoginPage().initialize(this));
        //            }
        //        }.bind(this)).fail(function (error) {
        //    this.consoleService.logError("Cannot obtain Settings for local Node Box: " + error);
        //    this
        //        .openConfirmationDialog("Failed to connect to Node Box. OK to retry.", function () {
        //            this.refreshServer();
        //        }.bind(this));
        //}.bind(this));
        // Reset previously selected node - whether connected locally or via proxy
    }
    else {
        this.consoleService.logDebug("Operating in proxy mode.");

        if (this.node) {
            this.node = null;
        }

        if (window.localStorage["thing-it.account"] != undefined && window.localStorage["thing-it.password"] != undefined &&
            window.localStorage["thing-it.account"] != "" && window.localStorage["thing-it.password"] != "") {
            this.login({
                account: window.localStorage["thing-it.account"],
                password: window.localStorage["thing-it.password"]
            });
        }
        else {
            this.rootPage(new LoginPage().initialize(this));
        }
    }
};

/**
 *
 */
MobileConsole.prototype.hasLocalConnection = function () {
    return this.consoleService.hasLocalConnection();
};

/**
 *
 */
MobileConsole.prototype.operatesInLocalMode = function () {
    return this.consoleService.operatesInLocalMode();
};

/**
 *
 */
MobileConsole.prototype.isPaired = function () {
    return this.consoleService.localSettings && this.consoleService.localSettings.uuid;
};

/**
 *
 */
MobileConsole.prototype.allowsLogout = function () {
    return !this.consoleService.hasLocalConnection() || (this.consoleService.settings.authentication && this.consoleService.settings.authentication != "none");
};

/**
 *
 */
MobileConsole.prototype.showPage = function (page, noPush) {
    this.startLoading();

    try {
        page.show().done(function () {
            if (!noPush) {
                this.pageStack.push(page);
            }

            window.location.href = "#/" + page.id;
            this.safeApply();
            this.stopLoading();
        }.bind(this)).fail(function (error) {
            this.consoleService.logError(error);
            this.pushHomePage(true);
            this.stopLoading();
        }.bind(this));
    }
    catch (error) {
        this.consoleService.logError(error);
        this.pushHomePage(true);
        this.stopLoading();
    }
};

/**
 *
 */
MobileConsole.prototype.topPage = function () {
    if (this.pageStack.length) {
        return this.pageStack[this.pageStack.length - 1];
    }

    return null;
};

/**
 *
 */
MobileConsole.prototype.pushPage = function (page) {
    if (this.topPage()) {
        this.topPage().leave();
    }

    this.showPage(page);
};

/**
 *
 */
MobileConsole.prototype.popPage = function () {
    if (this.topPage()) {
        try {
            this.pageStack.pop().leave();
        }
        catch (error) {
            this.consoleService.logError(error);
            this.pushHomePage(true);
        }
    }

    try {
        this.showPage(this.topPage(), true);
    }
    catch (error) {
        this.consoleService.logError(error);
        this.pushHomePage(true);
    }
};

/**
 *
 */
MobileConsole.prototype.rootPage = function (page, skipPop) {
    if (!skipPop) {
        if (this.topPage()) {
            this.pageStack.pop().leave();
        }
    }

    this.pageStack = [page];

    this.showPage(page);
};

/**
 *
 */
MobileConsole.prototype.openDeviceAdvertisementDialog = function () {
    // Only one advertisement at a time

    if (!this.Ui.isActive("deviceAdvertisementDialog")) {
        this.Ui.turnOn("deviceAdvertisementDialog");
    }
};

/**
 *
 */
MobileConsole.prototype.closeDeviceAdvertisementDialog = function () {
    this.Ui.turnOff("deviceAdvertisementDialog");
};

/**
 *
 */
MobileConsole.prototype.loadOn = function () {
    this.Ui.turnOn("loadOverlay");
};

/**
 *
 */
MobileConsole.prototype.loadOff = function () {
    this.Ui.turnOff("loadOverlay");
};

/**
 *
 */
MobileConsole.prototype.registerDevice = function () {
    this.consoleService.registerDevice(this.node, this.deviceAdvertisementDialog.device).done(function (device) {
        this.node.devices.push(device);
        Device.bind(this.deviceTypes, this.node, device);

        this
            .topPage().show()
            .then(function () {
                this.safeApply();
            }.bind(this));
        this.closeDeviceAdvertisementDialog();
    }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);
        this
            .openMessageDialog(error, "error");
    }.bind(this));
};

/**
 *
 * @param credentials
 */
MobileConsole.prototype.startLoading = function (loadingText) {
    this.loading = true;
    this.loadingText = loadingText;
};

MobileConsole.prototype.stopLoading = function (loadingText) {
    this.loading = false;
};

/**
 *
 */
MobileConsole.prototype.login = function (credentials) {
    this.startLoading();

    this.consoleService
        .login(credentials)
        .done(
            function (loggedInUser, status, headers) {
                this.loggedInUser = loggedInUser;

                if (this.passwordExpired()) {
                    this.rootPage(new LoginPage().initialize(this));
                }
                else {
                    this.afterLogin();
                }

            }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);

        this.loading = false;

        this.rootPage(new LoginPage().initialize(this));
        this
            .openMessageDialog(error, "error");
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.changePasswordAndLogin = function (account, password, newPassword) {
    this.consoleService
        .changePasswordAndLogin(account, password, newPassword)
        .done(
            function (loggedInUser) {
                this.loggedInUser = loggedInUser;

                this.afterLogin();
            }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);
        this.rootPage(new LoginPage().initialize(this));
        this
            .openMessageDialog(error, "error");
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.passwordExpired = function () {
    return this.loggedInUser
        && this.loggedInUser.passwordExpiration < new Date()
            .getTime();
};

/**
 *
 */
MobileConsole.prototype.afterLogin = function () {
    this.consoleService
        .getDeviceTypes()
        .done(
            function (deviceTypes) {
                this.deviceTypes = deviceTypes;

                this.consoleService.logDebug("Device Types retrieved", deviceTypes);
                this.consoleService.logDebug("Settings", this.consoleService.settings);
                this.consoleService.logDebug("Connection Mode", this.consoleService.connectionMode);

                if (this.operatesInLocalMode()) {
                    this.consoleService.logDebug("Get Node for local connection.");

                    this.consoleService
                        .getNode()
                        .done(
                            function (node) {
                                this.consoleService.logDebug("Node retrieved.", node);

                                this.node = node;

                                // TODO Local authorization - deprecate

                                //this.loggedInUser = User.bind(node, this.loggedInUser);

                                this
                                    .pushNodePage(
                                        node);
                            }.bind(this))
                        .fail(function (error) {
                            this
                                .openMessageDialog(error, "error");
                        }.bind(this));
                }
                else {
                    this.consoleService.logDebug("Adjusting style after login");
                    this.adjustStyle();
                    this.consoleService.logDebug("Adjusted style after login");

                    this.consoleService
                        .getMeshes()
                        .done(
                            function (meshes) {
                                this.meshes = meshes;

                                this.consoleService.logDebug("Meshes retrieved after login");

                                var mesh = this.singleNonDefaultMesh(meshes);

                                this
                                    .pushMeshesPage(meshes);

                                if (mesh) {
                                    this
                                        .pushMeshPage(mesh);
                                }
                            }.bind(this)).fail(function (error) {
                        this.consoleService.logError(error);
                        this.rootPage(new LoginPage().initialize(this));
                        this
                            .openMessageDialog(error, "error");
                    }.bind(this));
                }
            }.bind(this))
        .fail(function (error) {
            this.consoleService.logError(error);
            this.rootPage(new LoginPage().initialize(this));
            this
                .openMessageDialog(error, "error");
        }.bind(this));
};

/*
 *
 */
MobileConsole.prototype.singleNonDefaultMesh = function (meshes) {
    var mesh;

    for (var n in meshes) {
        if (n == 1) {
            mesh = meshes[n];
        }
        else if (n > 1) {
            return null;
        }
    }

    return mesh;
};

/*
 *
 */
MobileConsole.prototype.getNodeRootUrl = function () {
    return this.consoleService.getNodeRootUrl(this.node);
};

/**
 *
 */
MobileConsole.prototype.connectMesh = function (mesh) {
    if (this.mesh && this.mesh._id === mesh._id && this.eventNamespace) {
        return;
    }

    this.disconnectMesh();

    this.mesh = mesh;

    this.consoleService.connectMeshNamespace(this.io, this.mesh._id).done(function (namespace) {
        this.initializeEventNamespace(namespace)
    }.bind(this)).fail(function (error) {
        console.error(error);
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.disconnectMesh = function (mesh) {
    if (this.eventNamespace) {
        this.eventNamespace.removeAllListeners("connection");
        this.eventNamespace.removeAllListeners("disconnect");
        this.eventNamespace.removeAllListeners("post");
        this.eventNamespace.removeAllListeners("heartbeat");
        this.eventNamespace.removeAllListeners("deviceStateChange");
        this.eventNamespace.removeAllListeners("actorStateChange");
        this.eventNamespace.removeAllListeners("storyboardProgress");
        this.eventNamespace.removeAllListeners("deviceAdvertisement");
        this.eventNamespace.removeAllListeners("nodeConfigurationChange");

        this.eventNamespace = null;
    }

    this.mesh = null;
};

/**
 *
 */
MobileConsole.prototype.connectNode = function () {
    this.eventNamespace = this.consoleService.connectNodeNamespace(
        this.io, this.node);

    this.initializeEventNamespace(this.eventNamespace);
};

/**
 *
 */
MobileConsole.prototype.disconnectNode = function (node) {
    if (this.eventNamespace) {
        this.eventNamespace.removeAllListeners("connection");
        this.eventNamespace.removeAllListeners("disconnect");
        this.eventNamespace.removeAllListeners("post");
        this.eventNamespace.removeAllListeners("heartbeat");
        this.eventNamespace.removeAllListeners("deviceStateChange");
        this.eventNamespace.removeAllListeners("actorStateChange");
        this.eventNamespace.removeAllListeners("storyboardProgress");
        this.eventNamespace.removeAllListeners("deviceAdvertisement");
        this.eventNamespace.removeAllListeners("nodeConfigurationChange");

        this.eventNamespace = null;
    }

    this.node = null;
};

/**
 *
 */
MobileConsole.prototype.initializeEventNamespace = function (namespace) {
    this.eventNamespace = namespace;

    this.consoleService.logDebug("Connecting Event Namespace", this.eventNamespace);

    this.eventNamespace.on("connection", function () {
        this.consoleService.logDebug("Connected Event Namespace");
    }.bind(this));
    this.eventNamespace.on("disconnect", function () {
        this.consoleService.logDebug("Disconnected Event Namespace");
    }.bind(this));
    this.eventNamespace.on("post", function (post) {
        this.postListener.onPost(post);
    }.bind(this));
    this.eventNamespace.on("heartbeat", function (heartbeat) {
        this.onHeartbeat()
    }.bind(this));
    this.eventNamespace.on("deviceStateChange", function (deviceStateChange) {
        this.consoleService.logDebug("Receiving Device State Change", deviceStateChange);
        this.safeApply(function () {
            this.onDeviceStateChanged(deviceStateChange);
        }.bind(this));
    }.bind(this));
    this.eventNamespace.on("actorStateChange", function (actorStateChange) {
        this.consoleService.logDebug("Receiving Actor State Change", actorStateChange);
        this.safeApply(function () {
            this.onActorStateChanged(actorStateChange);
        }.bind(this));
    }.bind(this));
    this.eventNamespace.on("storyboardProgress", function (storyboardProgress) {
        this.consoleService.logDebug("Storyboard Progress");
        this.safeApply(function () {
            this.onStoryboardProgress(storyboardProgress);
        }.bind(this));
    }.bind(this));
    this.eventNamespace.on("deviceAdvertisement", function (device) {
        this.consoleService.logDebug("Device advertisement ", device);
        this.onDeviceAdvertisement(device);
    }.bind(this));
    this.eventNamespace.on("nodeConfigurationChange", function (message) {
        this.consoleService.logDebug("Node configuration Change");
        this.onNodeConfigurationChange(message.configuration, message.initiatingClient);
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.logout = function () {
    this.disconnectMesh();

    this.consoleService.logout().done(function () {
        this.loggedInUser = null;

        this.safeApply();
        this.rootPage(new LoginPage().initialize(this));
    }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);
        this
            .openMessageDialog(error, "error");
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.adjustStyle = function () {
    var customer;

    if (this.loggedInUser) {
        customer = this.loggedInUser.customer;

        window.localStorage["thing-it.tenant"] = this.loggedInUser.customer;
    }
    else if (window.localStorage["thing-it.tenant"]) {
        customer = window.localStorage["thing-it.tenant"];
    }

    if (customer) {
        this.consoleService.getCustomerStyle(customer).then(function (data) {
            jQuery("<style></style>").appendTo("head").html(data.css);

            this.style = data.style;

        }.bind(this)).fail(function () {
            this.consoleService.logDebug("No customer-specific style.");
        }.bind(this));
    }
};

/**
 *
 */
MobileConsole.prototype.pushTermsAndConditionsPage = function (previousPage) {
    this.pushPage(new TermsAndConditionsPage().initialize(this, previousPage));
};

/**
 *
 */
MobileConsole.prototype.pushMeshesPage = function (meshes, skipPop) {
    this.pushPage(new MeshesPage().initialize(this, meshes), skipPop);
};

/**
 *
 */
MobileConsole.prototype.pushMeshPage = function (mesh) {
    this.consoleService.logDebug("Pushing Mesh Page");

    this.pushPage(new MeshPage().initialize(this, mesh));
};

/**
 *
 */
MobileConsole.prototype.openNodePage = function (node, mesh) {
    this.node = node;

    this.pushNodePage();

    // TODO State refresh like in MeshPage?

    //this.consoleService
    //    .getNode(node, mesh)
    //    .done(
    //        function (node) {
    //            // TODO Ensure disconnect, e.g. on leave page (seems unelegant)
    //
    //            this.pushNodePage(node);
    //        }.bind(this)).fail(function (error) {
    //    this.consoleService.logError(error);
    //    this
    //        .openMessageDialog("Failed to retrieve Node details: " + error, "error");
    //});
};

/**
 *
 */
MobileConsole.prototype.pushNodePage = function () {
    this.pushPage(new NodePage().initialize(this));
};

/**
 *
 */
MobileConsole.prototype.pushHomePage = function (skipPop) {
    if (this.hasLocalConnection()) {
        this.rootPage(new NodePage().initialize(this), skipPop);
    }
    else {
        if (!this.loggedInUser) {
            this.rootPage(new LoginPage().initialize(this), skipPop);
        }
        else {
            this.consoleService
                .getMeshes()
                .done(
                    function (meshes) {
                        if (meshes.length == 1) {
                            this
                                .rootPage(new MeshPage().initialize(this, meshes[0]), skipPop);
                        } else {
                            this
                                .rootPage(new MeshesPage().initialize(this, meshes), skipPop);
                        }
                    }.bind(this)).fail(function (error) {
                console.trace(error);
            });
        }
    }
};

/**
 *
 */
MobileConsole.prototype.pushGroupPage = function (group) {
    this.pushPage(new GroupPage().initialize(this, group));
};

/**
 *
 */
MobileConsole.prototype.pushDevicePage = function (device) {
    this.pushPage(new DevicePage().initialize(this, device));
};

/**
 *
 */
MobileConsole.prototype.pushActorPage = function (actor) {
    this.pushPage(new ActorPage().initialize(this, actor));
};

/**
 *
 */
MobileConsole.prototype.pushSensorPage = function (sensor) {
    this.pushPage(new SensorPage().initialize(this, sensor));
};

/**
 *
 */
MobileConsole.prototype.pushMonitoringPage = function (component) {
    this.pushPage(new MonitoringPage().initialize(this, component));
};

/**
 *
 */
MobileConsole.prototype.pushDataPage = function (data) {
    this.pushPage(new DataPage().initialize(this, data));
};

/**
 *
 */
MobileConsole.prototype.pushSettingsPage = function () {
    this.testBeacon();
    this.pushPage(new SettingsPage().initialize(this));
};

/**
 *
 */
MobileConsole.prototype.pushUserManagementPage = function () {
    this.pushPage(new UserManagementPage().initialize(this));
};

/**
 *
 */
MobileConsole.prototype.openMessageDialog = function (message, type, timeout) {
    this.messageDialog.message = message;
    this.messageDialog.type = type;

    this.Ui.turnOn("messageDialog");
    this.safeApply();

    if (timeout) {
        setTimeout(function () {
            this.Ui.turnOff("messageDialog");
        }.bind(this), timeout)
    }
};

/**
 *
 */
MobileConsole.prototype.openConfirmationDialog = function (message, action, hideCancelButton) {
    this.confirmationDialog.message = message;
    this.confirmationDialog.action = action;
    this.confirmationDialog.hideCancelButton = hideCancelButton;

    this.Ui.turnOn("confirmationDialog");
};

/**
 *
 */
MobileConsole.prototype.confirmConfirmationDialog = function () {
    this.confirmationDialog.action();
    this.Ui.turnOff("confirmationDialog");
}

/**
 *
 */
MobileConsole.prototype.openLoginDialog = function (message, action) {
    this.loginDialog.message = message;
    this.loginDialog.action = action;

    this.Ui.turnOn("loginDialog");
};

/**
 *
 */
MobileConsole.prototype.confirmLoginDialog = function () {
    this.consoleService.login({
        account: this.loginDialog.account,
        password: this.loginDialog.password
    }).done(function () {
        // TODO Add remember me check

        if (true) {
            window.localStorage["thing-it.account"] = this.loginDialog.account;
            window.localStorage["thing-it.password"] = this.loginDialog.password;
        }

        this.loginDialog.action();
        this.Ui.turnOff("loginDialog");
    }.bind(this)).fail(function () {
        this.Ui.turnOff("loginDialog");
        this.openMessageDialog("Login failed.");
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.pushUserPage = function (user) {
    this.pushPage(SettingsPage.create(this, user));
};

/**
 *
 */
MobileConsole.prototype.pushNodeConfigurationPage = function () {
    this.pushPage(new NodeConfigurationPage().initialize(this));
};

/**
 *
 */
MobileConsole.prototype.pushDeviceConfigurationPage = function (device) {
    this.pushPage(new DeviceConfigurationPage().initialize(this, device));
};

/**
 *
 */
MobileConsole.prototype.pushActorConfigurationPage = function (device, index) {
    this.pushPage(new ActorConfigurationPage().initialize(this, device, index));
};

/**
 *
 */
MobileConsole.prototype.pushSensorConfigurationPage = function (device, index) {
    this.pushPage(new SensorConfigurationPage().initialize(this, device, index));
};

/**
 *
 */
MobileConsole.prototype.canOperateMesh = function (mesh) {
    if (this.hasLocalConnection() || mesh.user && mesh.user === this.loggedInUser._id) {
        return true;
    }

    for (var path in this.loggedInUser.entitlements.role[mesh._id]) {
        if (path === 'meshOperator' || path === 'meshDesigner') {
            return true;
        }
    }

    return false;
}

/**
 *
 */
MobileConsole.prototype.hasAnyEntitlements = function (group) {
    if (this.hasLocalConnection() || this.mesh.user && this.mesh.user === this.loggedInUser._id) {
        return true;
    }

    if (!group.entitlements) {
        return false;
    }

    for (var path in this.loggedInUser.entitlements.role[this.mesh._id]) {
        for (var m in group.entitlements.view) {
            if (group.entitlements.view[m] == path) {
                return true;
            }
        }

        for (var m in group.entitlements.operate) {
            if (group.entitlements.operate[m] == path) {
                return true;
            }
        }

        for (var m in group.entitlements.manage) {
            console.log("Manage: ", group.entitlements.manage[m]);

            if (group.entitlements.manage[m] == path) {
                return true;
            }
        }
    }

    for (var n in group.subGroups) {
        if (this.hasAnyEntitlements(group.subGroups[n])) {
            return true;
        }
    }

    return false;
};

/**
 *
 */
MobileConsole.prototype.canViewGroup = function (group) {
    if (this.hasLocalConnection() || this.mesh.user && this.mesh.user === this.loggedInUser._id) {
        return true;
    }

    if (!group.entitlements) {
        return false;
    }

    for (var path in this.loggedInUser.entitlements.role[this.mesh._id]) {
        for (var m in group.entitlements.view) {
            if (group.entitlements.view[m] == path) {
                return true;
            }
        }

        for (var m in group.entitlements.operate) {
            if (group.entitlements.operate[m] == path) {
                return true;
            }
        }

        for (var m in group.entitlements.manage) {
            if (group.entitlements.manage[m] == path) {
                return true;
            }
        }
    }

    return false;
};

/**
 *
 */
MobileConsole.prototype.canExecuteGroup = function (group) {
    if (this.hasLocalConnection() || this.mesh.user && this.mesh.user === this.loggedInUser._id) {
        return true;
    }

    if (!group.entitlements) {
        return false;
    }

    for (var path in this.loggedInUser.entitlements.role[this.mesh._id]) {
        for (var m in group.entitlements.operate) {
            if (group.entitlements.operate[m] == path) {
                return true;
            }
        }

        for (var m in group.entitlements.manage) {
            if (group.entitlements.manage[m] == path) {
                return true;
            }
        }
    }

    return false;
};

/**
 *
 */
MobileConsole.prototype.canManageGroup = function (group) {
    if (this.hasLocalConnection() || group.__node.__mesh.user && this.mesh.user === this.loggedInUser._id) {
        return true;
    }

    if (!group.entitlements) {
        return false;
    }

    for (var path in this.loggedInUser.entitlements.role[group.__node.__mesh._id]) {
        for (var m in group.manage) {
            if (group.manage[m] == path) {
                return true;
            }
        }
    }

    return false;
};

/**
 * TODO Deprecated?
 */
MobileConsole.prototype.checkEntitlementForGroup = function (nodeLevel, group, entitlement) {
    var segments = group.path().split(".");
    var path = "";

    for (var n in segments) {
        if (path.length) {
            path += ".";
        }

        path += segments[n];

        if (nodeLevel[path] && nodeLevel[path][entitlement]) {
            return true;
        }
    }

    return false;
}


/**
 *
 */
MobileConsole.prototype.openUserCreationDialog = function () {
    this.userCreationDialog.user = {};
};

/**
 *
 */
MobileConsole.prototype.pushGroupConfigurationPage = function (group, superGroup) {
    this.pushPage(new GroupConfigurationPage().initialize(this, group, superGroup));
};

/**
 *
 */
MobileConsole.prototype.pushServiceConfigurationPage = function (service) {
    this.pushPage(new ServiceConfigurationPage().initialize(this, service));
};

/**
 *
 */
MobileConsole.prototype.pushEventProcessorConfigurationPage = function (eventProcessor) {
    this.pushPage(new EventProcessorConfigurationPage().initialize(this, eventProcessor));
};

/**
 *
 */
MobileConsole.prototype.pushStoryboardConfigurationPage = function (storyboard) {
    this.pushPage(new StoryboardConfigurationPage().initialize(this, storyboard));
};

/**
 *
 */
MobileConsole.prototype.pushStoryboardStepConfigurationPage = function (storyboard, storyboardStepIndex) {
    this.pushPage(new StoryboardStepConfigurationPage().initialize(this, storyboard, storyboardStepIndex));
};

/**
 *
 */
MobileConsole.prototype.pushJobConfigurationPage = function (job) {
    this.pushPage(new JobConfigurationPage().initialize(this, job));
};

/**
 *
 */
MobileConsole.prototype.pushNotificationsPage = function () {
    this.pushPage(new NotificationsPage().initialize(this));
};

/**
 *
 */
MobileConsole.prototype.pushToDoPage = function (mesh) {
    this.pushPage(new ToDoPage().initialize(this, mesh));
};

/**
 *
 */
MobileConsole.prototype.pushTaskPage = function (mesh, task) {
    this.pushPage(new TaskPage().initialize(this, mesh, task));
};

/**
 *
 */
MobileConsole.prototype.pushProcessPage = function (mesh, process) {
    this.pushPage(new ProcessPage().initialize(this, mesh, process));
};

/**
 *
 */
MobileConsole.prototype.pushCommunicationPage = function (mesh) {
    this.pushPage(new CommunicationPage().initialize(this, mesh));
};

/**
 *
 */
MobileConsole.prototype.pushWikiPage = function (mesh) {
    this.pushPage(new WikiPage().initialize(this, mesh));
};

/**
 *
 */
MobileConsole.prototype.pushPagePage = function (mesh, page) {
    this.pushPage(new PagePage().initialize(this, mesh, page));
};

/**
 *
 */
MobileConsole.prototype.pushChannelPage = function (mesh, channel) {
    this.pushPage(new ChannelPage().initialize(this, mesh, channel));
};

/**
 *
 */
MobileConsole.prototype.createUser = function () {
    this.consoleService.createUser(this.node, this.userCreationDialog.user).done(function () {
        this.openMessageDialog("User created");
    }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);
        this.openMessageDialog(error);
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.isDeviceInGroups = function (node, device) {
    for (var n in node.groups) {
        if (node.groups[n].containsDevice(device)) {
            return true;
        }
    }

    return false;
};

/**
 *
 */
MobileConsole.prototype.isActorInGroups = function (node, actor) {
    for (var n in node.groups) {
        if (node.groups[n].containsActor(actor)) {
            return true;
        }
    }

    return false;
};

/**
 *
 */
MobileConsole.prototype.isSensorInGroups = function (node, sensor) {
    for (var n in node.groups) {
        if (node.groups[n].containsSensor(sensor)) {
            return true;
        }
    }

    return false;
};

/**
 *
 */
MobileConsole.prototype.pushSensorValue = function (sensor) {
    // TODO Deprecated cannot create sensor value from UI
    //this.consoleService.pushSensorValue(sensor).done(
    //    function () {
    //    }).fail(function (error) {
    //        console.trace(error);
    //
    //        this.openMessageDialog("Cannot push Sensor Event.");
    //    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.pushSensorEvent = function (sensor,
                                                    event) {
    // TODO Deprecated cannot create sensor value from UI
    //var self = this;
    //
    //this.consoleService
    //    .pushSensorEvent(sensor, event)
    //    .done(function () {
    //    })
    //    .fail(
    //    function (error) {
    //        console.trace(error);
    //
    //        this
    //            .openMessageDialog(error, "error");
    //    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.getNodeByUuid = function (uuid) {
    if (this.mesh) {
        return this.mesh.getNodeByUuid(uuid)
    } else if (this.node) {
        return this.node; // Local!!!
    }

    return null;
};

/**
 *
 */
MobileConsole.prototype.onHeartbeat = function (heartbeat) {
    var node = this.getNodeByUuid(heartbeat.node);

    if (node) {
        node.state = "running";
        node.lastHeartbeat = new Date().getTime();
    }

    this.safeApply();
};

/**
 *
 */
MobileConsole.prototype.onPost = function (post) {
    if (this.topPage().onPost) {
        this.topPage().onPost(post);
    }
};

/**
 *
 */
MobileConsole.prototype.onDeviceStateChanged = function (stateChange) {
    try {
        var node = this.getNodeByUuid(stateChange.node);

        if (!node) {
            this.consoleService.logError("Node " + stateChange.node + " cannot be found.");
        }

        var device = node.getDevice(stateChange.device);

        device._state = stateChange.state;
        device.lastStateChangeTimestamp = new Date().getTime();

        this.addDeviceState(device, stateChange.state);

        if (this.topPage().id == "deviceMonitoringPage"
            && this.topPage().device == device) {
            this.topPage().updatePlots();
        }
    }
    catch (error) {
        this.consoleService.logDebug(error);

        // Node may not be bound and Device may not be registered yet and is already firing updates
    }
};

/**
 *
 */
MobileConsole.prototype.onActorStateChanged = function (stateChange) {
    try {
        var node = this.getNodeByUuid(stateChange.node);

        if (!node) {
            return;
        }

        var actor = node.getDevice(stateChange.device)
            .getActor(stateChange.actor);

        actor._state = stateChange.state;
        actor.lastStateChangeTimestamp = new Date().getTime();
    }
    catch (error) {
        this.consoleService.logDebug(error);

        // Node may not be bound and Actor not be registered yet and is already firing updates
    }
};

/**
 *
 */
MobileConsole.prototype.onStoryboardProgress = function (storyboardProgress) {
    var node = this.getNodeByUuid(storyboardProgress.node);

    if (!node) {
        return;
    }

    var service = node.getService(storyboardProgress.storyboard);

    service.__elapsedTime = storyboardProgress.elapsedTime;

    // elapsedTime may be 0 which is different from null

    if (storyboardProgress.elapsedTime == null) {
        service.__status = "stopped";
    }
};

/**
 *
 */
MobileConsole.prototype.onDeviceAdvertisement = function (device) {
    this.deviceAdvertisementDialog.device = device;

    this.safeApply();
    this.openDeviceAdvertisementDialog();
};

/**
 *
 */
MobileConsole.prototype.onNodeConfigurationChange = function (nodeConfiguration, initiatingClient) {
    var node = this.getNodeByUuid(nodeConfiguration.uuid); // TODO Same UUID?

    if (!node) {
        return;
    }

    console.log("This Node " + this.node.uuid);
    console.log("This Config " + nodeConfiguration.uuid);
    console.log("Initiating Client " + initiatingClient);

    this.openConfirmationDialog("The configuration for this Node has changed. Switching back to Home Page.", function () {
        this.pushHomePage();
    }.bind(this), true)
};

/**
 *
 */
MobileConsole.prototype.callNodeService = function (node, service) {
    if (service.parameters && service.parameters.length > 0) {
        this.serviceCallDialog.service = service;
        this.serviceCallDialog.parameters = {};
        this.serviceCallDialog.callService = function () {
            this.consoleService.callNodeService(node, service, this.serviceCallDialog.parameters)
                .done(function () {
                }).fail(function (error) {
                this.consoleService.logError(error);
                this
                    .openMessageDialog(error, "error");
            }.bind(this));
        }.bind(this)
        this.Ui.turnOn("serviceCallDialog");
        this.safeApply();
    } else {

        if (service.type == "storyboard") {
            service.__status = "playing";
            service.__elapsedTime = 0;
        }

        this.consoleService.callNodeService(node, service, parameters)
            .done(function () {
            }).fail(function (error) {
            this.consoleService.logError(error);
            this
                .openMessageDialog(error, "error");
        }.bind(this));
    }
};

/**
 *
 */
MobileConsole.prototype.startStoryboard = function (node, storyboard) {
    storyboard.__status = "playing";
    storyboard.__elapsedTime = 0;

    this.consoleService.callNodeService(node, storyboard)
        .done(function () {
        }).fail(function (error) {
        this.consoleService.logError(error);
        this
            .openMessageDialog(error, "error");
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.playStoryboard = function (node, storyboard) {
    this.consoleService.playStoryboard(node, storyboard)
        .done(function () {
            storyboard.__status = "playing";
        }).fail(function (error) {
        this.consoleService.logError(error);
        this
            .openMessageDialog(error, "error");
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.pauseStoryboard = function (node, storyboard) {
    this.consoleService.pauseStoryboard(node, storyboard)
        .done(function () {
            storyboard.__status = "paused";
        }).fail(function (error) {
        this.consoleService.logError(error);
        this
            .openMessageDialog(error, "error");
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.stopStoryboard = function (node, storyboard) {
    this.consoleService.stopStoryboard(node, storyboard)
        .done(function () {
            storyboard.__status = "stopped";
        }).fail(function (error) {
        this.consoleService.logError(error);
        this
            .openMessageDialog(error, "error");
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.callDeviceService = function (device, service, parameters) {
    if (!parameters && device.getService(service).parameters && device.getService(service).parameters.length > 0) {
        this.serviceCallDialog.service = device.getService(service);
        this.serviceCallDialog.parameters = {};
        this.serviceCallDialog.callService = function () {
            console.log("Calling service " + service + " with parameters ", this.serviceCallDialog.parameters);
            this.consoleService.callDeviceService(device, service, this.serviceCallDialog.parameters)
                .done(function () {
                }).fail(function (error) {
                this.consoleService.logError(error);
                this
                    .openMessageDialog(error, "error");
            }.bind(this));
        }.bind(this)
        this.Ui.turnOn("serviceCallDialog");
        this.safeApply();
    } else {
        this.consoleService.callDeviceService(device, service, parameters)
            .done(function () {
            }).fail(function (error) {
            this.consoleService.logError(error);
            this
                .openMessageDialog(error, "error");
        }.bind(this));
    }
};


/**
 *
 */
MobileConsole.prototype.getDeviceStateResourceUrl = function (device, stateVariable) {
    return this.consoleService.getDeviceStateResourceUrl(device, stateVariable);
};

/**
 *
 */
MobileConsole.prototype.callActorService = function (actor,
                                                     service, parameters) {
    if (!parameters && actor.getService(service).parameters && actor.getService(service).parameters.length > 0) {
        this.serviceCallDialog.service = actor.getService(service);
        this.serviceCallDialog.parameters = {};
        this.serviceCallDialog.callService = function () {
            this.consoleService.callActorService(actor, service, this.serviceCallDialog.parameters)
                .done(function () {
                }).fail(function (error) {
                this.consoleService.logError(error);
                this
                    .openMessageDialog(error, "error");
            }.bind(this));
        }.bind(this)
        this.Ui.turnOn("serviceCallDialog");
        this.safeApply();
    } else {
        this.consoleService.callActorService(actor, service,
            parameters).done(function () {
        }).fail(function (error) {
            this.consoleService.logError(error);
            this
                .openMessageDialog(error, "error");
        }.bind(this));
    }
};

/*
 *
 */
MobileConsole.prototype.getComponentPluginPath = function (component) {
    return this.consoleService.getComponentPluginPath(
        component);
};

/*
 *
 */
MobileConsole.prototype.getComponentPluginDirectory = function (component) {
    return this.consoleService.getComponentPluginDirectory(
        component);
};

/**
 *
 */
MobileConsole.prototype.addDeviceState = function (device,
                                                   state) {
    if (!this.plotData[device.id]) {
        return;
    }

    for (var n in device.__type.state) {
        var field = device.__type.state[n];

        if (field.type.id != "number") {
            continue;
        }

        var plotData = this.plotData[device.id][field.id];
        var now = new Date().getTime();

        while (plotData.series[0][0] < now - plotData.interval) {
            plotData.series.shift();
        }

        plotData.series.push([now, state[field.id]]);
    }
};

/**
 *
 */
MobileConsole.prototype.addValue = function (device, sensor,
                                             value) {
    if (!this.sensorPlotData[device]
        || !this.sensorPlotData[device][sensor]) {
        return;
    }

    var plotData = this.sensorPlotData[device][sensor];
    var now = new Date().getTime();

    while (plotData.series[0][0] < now - plotData.interval) {
        plotData.series.shift();
    }

    plotData.series.push([now, value]);
};

/**
 *
 */
MobileConsole.prototype.writeToDeviceStream = function (device,
                                                        value) {
};

/**
 *
 */
MobileConsole.prototype.loggedInUserIsAdministrator = function (time) {
    if (!this.loggedInUser) {
        return false;
    }

    return this.loggedInUser.hasRole("administrator");
};

/**
 *
 */
MobileConsole.prototype.bindNode = function (node) {
    this.node = Node.bind(this.deviceTypes,
        node, this.node.__mesh);
};

// TODO Move back to DeviceConfigurationPage

/**
 *
 */
MobileConsole.prototype.createDevice = function (device) {
    var deferred = $.Deferred();

    this.consoleService.createDevice(this.node, device).done(function (node) {
        this.node = Node.bind(this.deviceTypes,
            node, this.node.__mesh);

        deferred.resolve();
    }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);

        deferred.reject(error);
    }.bind(this));

    return deferred.promise();
};

/**
 *
 */
MobileConsole.prototype.updateDevice = function (device) {
    var deferred = $.Deferred();

    this.consoleService.updateDevice(device).done(function (node) {
        this.node = Node.bind(this.deviceTypes,
            node, this.node.__mesh);

        deferred.resolve();
    }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);

        deferred.reject(error);
    }.bind(this));

    return deferred.promise();
};

/**
 *
 */
MobileConsole.prototype.deleteDevice = function (device) {
    var deferred = $.Deferred();

    this.consoleService.deleteDevice(device).done(function (node) {
        this.node = Node.bind(this.deviceTypes,
            node, this.node.__mesh);

        deferred.resolve();
    }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);

        deferred.reject(error);
    }.bind(this));

    return deferred.promise();
};

/**
 *
 */
MobileConsole.prototype.createActor = function (device, actor) {
    this.consoleService.createActor(this.node, device, actor).done(function (node) {
        this.node = node;

        this.popPage();
    }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.updateActor = function (device, actor) {
    this.consoleService.updateActor(this.node, device, actor).done(function (node) {
        this.node = node;

        this.popPage();
    }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.createSensor = function (device, sensor) {
    this.consoleService.createSensor(this.node, device, sensor).done(function (node) {
        this.node = node;

        this.popPage();
    }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.updateSensor = function (device, sensor) {
    this.consoleService.updateSensor(this.node, device, sensor).done(function (node) {
        this.node = node;

        this.popPage();
    }.bind(this)).fail(function (error) {
        this.consoleService.logError(error);
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.actorType = function (device, actorType) {
    if (!device || !actorType) {
        return null;
    }

    var deviceType = this.consoleService.deviceTypes[device.plugin];

    for (var n in deviceType.actorTypes) {
        if (deviceType.actorTypes[n].plugin == actorType) {
            return deviceType.actorTypes[n];
        }
    }

    return null;
};

/**
 *
 */
MobileConsole.prototype.sensorType = function (device, sensorType) {
    if (!device || !sensorType) {
        return null;
    }

    var deviceType = this.consoleService.deviceTypes[device.plugin];

    for (var n in deviceType.sensorTypes) {
        if (deviceType.sensorTypes[n].plugin == sensorType) {
            return deviceType.sensorTypes[n];
        }
    }

    return null;
};

/**
 *
 */
MobileConsole.prototype.capturePhoto = function (element, prefix) {
    if (!navigator.camera) {
        alert("Camera API not supported", "Error");

        return;
    }
    else {
        navigator.camera.getPicture(function (uri) {
            this.photo = "data:image/jpeg;base64," + uri;
            this.safeApply();

            try {
                this.consoleService.uploadPhoto(this.node, uri, prefix + "Photo-" + element.id + ".jpg").done(function (uri) {
                    element.photoUri = prefix + "Photo-" + element.id + ".jpg";

                    this.safeApply();
                }.bind(this)).fail(function (error) {
                    alert("Photo not uploaded: " + error.code);
                }.bind(this));
            }
            catch (error) {
                alert("Photo not uploaded: " + error);
            }
        }.bind(this), null, {
            quality: 30,
            destinationType: Camera.DestinationType.FILE_URI,
            sourceType: 1,      // 0:Photo Library, 1=Camera, 2=Saved Album
            encodingType: 0     // 0=JPG 1=PNG
        });
    }
};

/**
 *
 */
MobileConsole.prototype.startFlow = function (mesh, flow) {
    this.consoleService.startFlow(mesh, flow).done(function () {
        alert("Flow was started.");
    }.bind(this)).fail(function (error) {
        alert("Flow could not be started.");
    }.bind(this));
};

/**
 *
 */
MobileConsole.prototype.capturePhotoAndStartFlow = function (mesh, flow) {
    if (!navigator.camera) {
        alert("Camera API not supported", "Error");

        return;
    }
    else {
        navigator.camera.getPicture(function (uri) {
            this.photo = "data:image/jpeg;base64," + uri;
            this.safeApply();

            try {
                this.consoleService.uploadPhotoAndStartFlow(uri, mesh, flow, "Photo-" + flow.id + ".jpg").done(function () {
                    alert("Photo was uploaded.");
                }.bind(this)).fail(function (error) {
                    alert("Photo not uploaded: " + error);
                }.bind(this));
            }
            catch (error) {
                alert("Photo not uploaded: " + error);
            }
        }.bind(this), null, {
            quality: 30,
            destinationType: Camera.DestinationType.FILE_URI,
            sourceType: 1,      // 0:Photo Library, 1=Camera, 2=Saved Album
            encodingType: 0     // 0=JPG 1=PNG
        });
    }
};

/*
 *
 */
MobileConsole.prototype.allowedNodeConfiguration = function (node) {
    if (!node || !this.loggedInUser) {
        return false;
    }

    if (this.hasLocalConnection()) {
        return true;
    }

    if (node.__mesh && node.__mesh.customer._id === this.loggedInUser.customer) {
        return true;
    }

    if (this.loggedInUser.entitlements && this.loggedInUser.entitlements.mesh && this.loggedInUser.entitlements.mesh[node.__mesh._id]) {
        return this.loggedInUser.entitlements.mesh[node.__mesh._id].manage;
    }

    return false;
};


MobileConsole.prototype.testBeacon = function () {
    var logToDom = function (message) {
        this.consoleService.logDebug("Beacon Message", message);
        console.log("Beacon Message", message);
    }.bind(this);

    var delegate = new cordova.plugins.locationManager.Delegate();

    delegate.didDetermineStateForRegion = function (pluginResult) {

        logToDom('>>> didDetermineStateForRegion: ' + JSON.stringify(pluginResult));

        cordova.plugins.locationManager.appendToDeviceLog('[DOM] didDetermineStateForRegion: '
            + JSON.stringify(pluginResult));
    }.bind(this);

    delegate.didStartMonitoringForRegion = function (pluginResult) {
        logToDom('>>> didStartMonitoringForRegion:' + JSON.stringify(pluginResult));
    }.bind(this);

    delegate.didRangeBeaconsInRegion = function (pluginResult) {
        logToDom('>>> didRangeBeaconsInRegion: ' + JSON.stringify(pluginResult));
    }.bind(this);

    var uuid = 'e2c56db5-dffb-48d2-b060-d0f5a71096e0';
    var identifier = 'MiniBeacon_32465';
    var minor = 0;
    var major = 0;
    var beaconRegion = new cordova.plugins.locationManager.BeaconRegion(identifier, uuid, major, minor);

    cordova.plugins.locationManager.setDelegate(delegate);

// required in iOS 8+
    cordova.plugins.locationManager.requestWhenInUseAuthorization();
// or cordova.plugins.locationManager.requestAlwaysAuthorization()

    cordova.plugins.locationManager.startMonitoringForRegion(beaconRegion)
        .fail(console.error)
        .done(function () {
        }.bind(this));
}

/*
 *
 */
MobileConsole.prototype.safeApply = function (fn) {
    if (this.rootScope && (this.rootScope.$$phase == "$apply" || this.rootScope.$$phase == "$digest")) {
        if (fn && (typeof (fn) === 'function')) {
            fn();
        }
    } else {
        this.rootScope.$apply(fn);
    }
};

angular.module('ThingItMobile.Main', [])
    .controller('mobileConsole', MobileConsole);